<template>
  <v-dialog v-model="dialog"  fullscreen hide-overlay transition="dialog-bottom-transition">
    <template v-slot:activator="{ on }">
      <v-btn
        v-on="on"
      >
        Crop
      </v-btn>
    </template>

    <v-card>
      <v-card-title
        class="headline grey lighten-2"
        primary-title
      >
        Cropping image
        <v-spacer></v-spacer>
        <v-btn @click="close">Cancel</v-btn>
        <v-btn
          color="primary"
          :disabled="isLoading"
          :loading="isLoading"
          text
          @click="crop"
        >
          Save
        </v-btn>
      </v-card-title>

      <v-card-text>
        <!-- без v-if="dialog" кроппер работает некорректно -->
        <cropper
          v-if="dialog"
          ref="cropper"
          classname="cropper"
          :src="value"
          :stencil-props="{ aspectRatio: aspectRatio }"
        ></cropper>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { Cropper } from 'vue-advanced-cropper'
import { StorageApi } from '../common/api'
import { canvasToBlob, delay } from '../util'

export default {
  components: { Cropper },
  props: ['value', 'suggest', 'aspectRatio'],
  data () {
    return {
      dialog: false,
      isLoading: false
    }
  },
  watch: {
    async dialog (val) {
      if (!val) return null
      await delay(1000)
      try {
        if (this.$refs.cropper) {
          this.$refs.cropper.setCoordinates((coordinates, imageSize) => ({
            width: imageSize.width,
            height: imageSize.height
          }))
        }
      } catch (e) {
        console.error(e)
      }
    }
  },
  methods: {
    async crop () {
      const { canvas } = this.$refs.cropper.getResult()
      const file = await canvasToBlob(canvas)
      await this.upload({ file, name: 'cropped.jpg' })
    },
    async upload ({ file, name }) {
      this.isLoading = true
      try {
        const { data } = await StorageApi.upload('image', name, file, this.suggest)
        this.$emit('input', data.url)
        this.close()
      } catch (e) {
        alert('Ошибка при загрузке картинки на сервер')
        console.error(e)
      } finally {
        this.isLoading = false
      }
    },
    close () {
      this.dialog = false
    }
  }
}
</script>

<style>
  .cropper {
    height: calc(100vh - 140px);
  }
</style>
